import { OpinionSlideContext } from '@/modules/opinions';

import { useContext } from 'react';

export const useOpinionContext = () => {
  const context = useContext(OpinionSlideContext);
  if (!context) {
    throw new Error('useOpinionContext must be used within an OpinionProvider');
  }
  return context;
};
